var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-63"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-63",
    cx: 250.11,
    cy: 316.94,
    rx: 236.67,
    ry: 136.64,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-63"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-63",
    cx: 428.84,
    cy: 396.29,
    rx: 47.07,
    ry: 27.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M129.09,343.48l119.83,69.19a9.49,9.49,0,0,0,8.56,0l156.35-90c2.36-1.36,2.36-3.56,0-4.92L293.44,248.42a9.49,9.49,0,0,0-8.56,0L129.09,338.54C126.73,339.91,126.73,342.12,129.09,343.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M103.61,326.57,43.21,291.7c-2.39-1.38-2.39-3.63,0-5,15-8.73,64.11-37.21,64.74-37.36s49.86,28.63,64.9,37.43c2.38,1.4,2.37,3.64,0,5l-60.55,34.79A9.57,9.57,0,0,1,103.61,326.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M311.3,219.16c13.35-7.7,35-7.7,48.33,0,11.31,6.53,13,16.5,5.16,24.08a5.74,5.74,0,0,1,1.27.52l42.16,24.34c1.79,1,1.79,2.71,0,3.74l-2.64,1.52a6.62,6.62,0,0,1-6.37-.18L360,247.49a2.37,2.37,0,0,1-.45-.36c-13.36,7.63-34.9,7.61-48.2-.07S298,226.87,311.3,219.16Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.55,224.18v8.3c0,4.5,3,9,8.93,12.45,11.91,6.87,31.22,6.87,43.13,0,5.95-3.44,8.93-8,8.93-12.45v-8.3h0c0-4.51-3-9-8.93-12.45-11.91-6.88-31.22-6.88-43.13,0-6,3.43-8.93,7.94-8.93,12.45Zm58,0c0,3.6-2.65,7.12-7.45,9.89-5.32,3.07-12.46,4.76-20.09,4.76s-14.78-1.69-20.09-4.76c-4.81-2.77-7.46-6.29-7.46-9.89s2.65-7.12,7.46-9.9c5.31-3.07,12.45-4.76,20.09-4.76s14.77,1.69,20.09,4.76C360.94,217.06,363.59,220.57,363.59,224.18Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,241.77v8.29c-8.13.15-16.35-1.55-22.56-5.13-6-3.44-8.93-8-8.93-12.45v-8.3a8.06,8.06,0,0,1,0-.85c-.39,4.78,2.57,9.64,8.9,13.3S328.91,241.92,337,241.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.61,211.73c-11.91-6.88-31.22-6.88-43.13,0s-11.91,18,0,24.9,31.22,6.87,43.13,0S369.52,218.6,357.61,211.73Zm-1.47,22.34c-5.32,3.07-12.46,4.76-20.09,4.76s-14.77-1.69-20.09-4.76c-4.81-2.77-7.46-6.29-7.46-9.89s2.65-7.12,7.46-9.9c5.32-3.07,12.45-4.76,20.09-4.76s14.77,1.69,20.09,4.76c4.81,2.78,7.45,6.29,7.45,9.9S361,231.3,356.14,234.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.6,224.18a8.16,8.16,0,0,1-1.2,4.15,16.47,16.47,0,0,0-6.27-5.75c-5.31-3.07-12.45-4.76-20.09-4.76s-14.76,1.69-20.08,4.76a16.74,16.74,0,0,0-6.28,5.75,8.33,8.33,0,0,1-1.18-4.15c0-3.61,2.65-7.12,7.46-9.9,5.32-3.07,12.45-4.76,20.08-4.76s14.78,1.69,20.09,4.76C361,217.06,363.6,220.57,363.6,224.18Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.14,218c-5.32-3.07-12.46-4.76-20.09-4.76S321.28,215,316,218c-4,2.29-6.46,5.08-7.21,8,.75,2.93,3.24,5.72,7.21,8,5.32,3.07,12.45,4.76,20.09,4.76s14.77-1.69,20.09-4.76c4-2.29,6.46-5.08,7.21-8C362.6,223.12,360.11,220.33,356.14,218Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.7,241.91a4.77,4.77,0,0,1,2.12-3.71,1.51,1.51,0,0,1,1.51-.16h0l10.26,5.85h0a1.53,1.53,0,0,1,.63,1.38,4.75,4.75,0,0,1-2.13,3.71,1.51,1.51,0,0,1-1.51.15h0l-10.26-5.86h0A1.51,1.51,0,0,1,356.7,241.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.34,243.29a1.51,1.51,0,0,1-.64-1.38,4.13,4.13,0,0,1,.37-1.6l13.23,7.57a4.07,4.07,0,0,1-1.19,1.12,1.51,1.51,0,0,1-1.51.15l-10.26-5.86Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.31,246h0l-.22.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,266.47,368.32,246a5.37,5.37,0,0,1,1.82-1.9,2,2,0,0,1,1.93-.22h0l34,18.18Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,266.47,368.32,246a5.37,5.37,0,0,1,1.82-1.9,2,2,0,0,1,1.93-.22h0l34,18.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,266.47l-2.61,4.62-32.87-20.32a2,2,0,0,1-.83-1.8,5.17,5.17,0,0,1,.27-1.56c0-.09.08-.2.11-.29.11-.25.22-.49.34-.73l.21-.35Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,266.47l-2.61,4.62-32.87-20.32a2,2,0,0,1-.83-1.8,5.17,5.17,0,0,1,.27-1.56c0-.09.08-.2.11-.29.11-.25.22-.49.34-.73l.21-.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.64,270.83a8.06,8.06,0,0,0,3.62-6.34c0-2.32-1.64-3.26-3.65-2.09a8.06,8.06,0,0,0-3.62,6.33C400,271.06,401.63,272,403.64,270.83Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403.64,270.83a8.06,8.06,0,0,0,3.62-6.34c0-2.32-1.64-3.26-3.65-2.09a8.06,8.06,0,0,0-3.62,6.33C400,271.06,401.63,272,403.64,270.83Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lines--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.93,385.59a5.81,5.81,0,0,1-2.85-.69L77.79,331.61a2.07,2.07,0,0,1,0-3.86l21.76-12.57.5.87L78.29,328.61a1.37,1.37,0,0,0-.83,1.07,1.4,1.4,0,0,0,.83,1.07L170.58,384a5.25,5.25,0,0,0,4.7,0L193,373.8l.5.87L175.78,384.9A5.84,5.84,0,0,1,172.93,385.59Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93,395a5.81,5.81,0,0,1-2.85-.69L61.54,331.61a2.07,2.07,0,0,1,0-3.86l29.9-17.27.5.87L62,328.61a1.1,1.1,0,0,0,0,2.14l108.54,62.66a5.25,5.25,0,0,0,4.7,0l25.83-14.91.5.86-25.83,14.92A5.84,5.84,0,0,1,172.93,395Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93,404.35a5.81,5.81,0,0,1-2.85-.69L45.29,331.61A2.29,2.29,0,0,1,44,329.68a2.32,2.32,0,0,1,1.32-1.94l38-21.95.5.87-38,21.95a1.1,1.1,0,0,0,0,2.13l124.79,72.05a5.25,5.25,0,0,0,4.7,0l34-19.6.5.86-34,19.61A5.84,5.84,0,0,1,172.93,404.35Z",
    style: {
      fill: "#BA1654"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--server--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 268.7 107.94 306.23 172.93 268.7 107.94 231.18 42.94 268.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93,306.22v17.3a8.84,8.84,0,0,1-4.32-1h0L75.44,306.23,45.54,289a5.73,5.73,0,0,1-2.6-4.5V268.7l63.2,36.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93,268.7v15.76a5.76,5.76,0,0,1-2.6,4.5l-25.84,14.92-32.23,18.61a8.86,8.86,0,0,1-4.33,1v-17.3l2-1.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,276.24v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25V277a1,1,0,0,0-.43-.75l-.49-.28C47.2,275.85,47,276,47,276.24Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,277.5v2.12a.94.94,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C49.39,277.11,49.19,277.22,49.19,277.5Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,278.76v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28C51.58,278.37,51.38,278.48,51.38,278.76Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,280v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V280.8a1,1,0,0,0-.43-.75l-.49-.28C53.76,279.63,53.57,279.75,53.57,280Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,281.28v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C56,280.9,55.76,281,55.76,281.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,282.54v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.29C58.14,282.16,58,282.27,58,282.54Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,283.81v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C60.33,283.42,60.14,283.53,60.14,283.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,285.07v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C62.52,284.68,62.32,284.79,62.32,285.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,286.33v2.12a1,1,0,0,0,.43.75l.49.29c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28C64.71,285.94,64.51,286.05,64.51,286.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,287.59v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C66.89,287.2,66.7,287.31,66.7,287.59Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,288.85V291a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C69.08,288.46,68.89,288.58,68.89,288.85Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,290.11v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V290.9a.93.93,0,0,0-.43-.75l-.49-.29C71.27,289.73,71.08,289.84,71.08,290.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,291.38v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C73.46,291,73.27,291.1,73.27,291.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,292.64v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C75.65,292.25,75.45,292.36,75.45,292.64Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,293.9V296a.94.94,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C77.84,293.51,77.64,293.62,77.64,293.9Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,295.16v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C80,294.77,79.83,294.88,79.83,295.16Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,296.42v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V297.2a1,1,0,0,0-.43-.75l-.49-.28C82.21,296,82,296.15,82,296.42Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,282.54v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.29C47.2,282.16,47,282.27,47,282.54Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,283.81v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C49.39,283.42,49.19,283.53,49.19,283.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,285.07v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.49-.28C51.58,284.68,51.38,284.79,51.38,285.07Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,286.33v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C53.76,285.94,53.57,286.05,53.57,286.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,287.59v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C56,287.2,55.76,287.31,55.76,287.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,288.85V291a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C58.14,288.46,58,288.58,58,288.85Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,290.11v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25V290.9a1,1,0,0,0-.43-.75l-.49-.29C60.33,289.73,60.14,289.84,60.14,290.11Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,291.38v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.28C62.52,291,62.32,291.1,62.32,291.38Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,292.64v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.49-.28C64.71,292.25,64.51,292.36,64.51,292.64Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,293.9V296a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C66.89,293.51,66.7,293.62,66.7,293.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,295.16v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C69.08,294.77,68.89,294.88,68.89,295.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,296.42v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V297.2a1,1,0,0,0-.43-.75l-.49-.28C71.27,296,71.08,296.15,71.08,296.42Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,297.68v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C73.46,297.3,73.27,297.41,73.27,297.68Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,298.94v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.29C75.65,298.56,75.45,298.67,75.45,298.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,300.21v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25V301a1,1,0,0,0-.44-.75l-.48-.28C77.84,299.82,77.64,299.93,77.64,300.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,301.47v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C80,301.08,79.83,301.19,79.83,301.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,302.73v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C82.21,302.34,82,302.45,82,302.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,303.62l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.3,1.3,0,0,1-.55,1.21h0l-.92.53-.17-.27a2.3,2.3,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,303.62l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.3,1.3,0,0,1-.55,1.21h0l-.92.53-.17-.27a2.3,2.3,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,303.73A4.14,4.14,0,0,1,92.58,307c0,1.2-.84,1.68-1.88,1.08a4.16,4.16,0,0,1-1.88-3.26C88.82,303.61,89.66,303.13,90.7,303.73Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,308.33l1-.57h0a1.29,1.29,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.8,1.8,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,308.33l1-.57h0a1.29,1.29,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.8,1.8,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,308.44a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.69-1.88,1.09A4.17,4.17,0,0,1,97,309.53C97,308.33,97.83,307.84,98.87,308.44Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 240.56 107.94 278.08 172.93 240.56 107.94 203.04 42.94 240.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 259.32 107.94 296.85 107.94 278.08 42.94 240.56 42.94 259.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.94 296.85 172.93 259.32 172.93 240.56 107.94 278.08 107.94 296.85",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.07 268.7 51.07 264.01 107.94 296.85 107.94 301.54 51.07 268.7",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 261.67 168.87 266.36 107.94 301.54 107.94 296.85 168.87 261.67",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 261.67 168.87 266.36 107.94 301.54 107.94 296.85 168.87 261.67",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,248.1v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C47.2,247.71,47,247.82,47,248.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,249.36v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C49.39,249,49.19,249.08,49.19,249.36Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,250.62v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25V251.4a1,1,0,0,0-.44-.75l-.49-.28C51.58,250.23,51.38,250.34,51.38,250.62Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,251.88V254a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C53.76,251.49,53.57,251.6,53.57,251.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,253.14v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C56,252.75,55.76,252.87,55.76,253.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,254.4v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C58.14,254,58,254.13,58,254.4Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,255.66v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.29C60.33,255.28,60.14,255.39,60.14,255.66Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,256.93v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C62.52,256.54,62.32,256.65,62.32,256.93Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,258.19v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25V259a1,1,0,0,0-.44-.75l-.49-.28C64.71,257.8,64.51,257.91,64.51,258.19Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,259.45v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C66.89,259.06,66.7,259.17,66.7,259.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,260.71v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C69.08,260.32,68.89,260.43,68.89,260.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,262v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13A1,1,0,0,0,72,262l-.49-.28C71.27,261.58,71.08,261.7,71.08,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,263.23v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25V264a1,1,0,0,0-.43-.75L73.7,263C73.46,262.85,73.27,263,73.27,263.23Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,264.5v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.28C75.65,264.11,75.45,264.22,75.45,264.5Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,265.76v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C77.84,265.37,77.64,265.48,77.64,265.76Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,267v2.12a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V267.8a1,1,0,0,0-.43-.75l-.49-.28C80,266.63,79.83,266.74,79.83,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,268.28v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C82.21,267.89,82,268,82,268.28Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,254.4v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C47.2,254,47,254.13,47,254.4Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,255.66v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.29C49.39,255.28,49.19,255.39,49.19,255.66Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,256.93v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.49-.28C51.58,256.54,51.38,256.65,51.38,256.93Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,258.19v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V259a1,1,0,0,0-.43-.75l-.49-.28C53.76,257.8,53.57,257.91,53.57,258.19Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,259.45v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C56,259.06,55.76,259.17,55.76,259.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,260.71v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C58.14,260.32,58,260.43,58,260.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,262v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C60.33,261.58,60.14,261.7,60.14,262Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,263.23v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25V264a.94.94,0,0,0-.44-.75l-.48-.29C62.52,262.85,62.32,263,62.32,263.23Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,264.5v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.49-.28C64.71,264.11,64.51,264.22,64.51,264.5Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,265.76v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C66.89,265.37,66.7,265.48,66.7,265.76Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,267v2.12a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V267.8a1,1,0,0,0-.43-.75l-.49-.28C69.08,266.63,68.89,266.74,68.89,267Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,268.28v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C71.27,267.89,71.08,268,71.08,268.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,269.54v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C73.46,269.15,73.27,269.27,73.27,269.54Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,270.8v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28A.27.27,0,0,0,75.45,270.8Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,272.06v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.29C77.84,271.68,77.64,271.79,77.64,272.06Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,273.33v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C80,272.94,79.83,273.05,79.83,273.33Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,274.59v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C82.21,274.2,82,274.31,82,274.59Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,275.48l1-.58h0a1.32,1.32,0,0,1,1.32.14,4.14,4.14,0,0,1,1.88,3.25,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.86,1.86,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,275.48l1-.58h0a1.32,1.32,0,0,1,1.32.14,4.14,4.14,0,0,1,1.88,3.25,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.86,1.86,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,275.58a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.69-1.88,1.09a4.16,4.16,0,0,1-1.88-3.26C88.82,275.47,89.66,275,90.7,275.58Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,280.19l1-.57h0a1.29,1.29,0,0,1,1.32.13A4.16,4.16,0,0,1,101.7,283a1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21A4.16,4.16,0,0,1,97.64,281a1.75,1.75,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,280.19l1-.57h0a1.29,1.29,0,0,1,1.32.13A4.16,4.16,0,0,1,101.7,283a1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21A4.16,4.16,0,0,1,97.64,281a1.75,1.75,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,280.3a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.68-1.88,1.08A4.15,4.15,0,0,1,97,281.39C97,280.18,97.83,279.7,98.87,280.3Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 212.42 107.94 249.94 172.93 212.42 107.94 174.89 42.94 212.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 231.18 107.94 268.7 107.94 249.94 42.94 212.42 42.94 231.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.94 268.7 172.93 231.18 172.93 212.42 107.94 249.94 107.94 268.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.07 240.56 51.07 235.87 107.94 268.7 107.94 273.39 51.07 240.56",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 233.52 168.87 238.21 107.94 273.39 107.94 268.7 168.87 233.52",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 233.52 168.87 238.21 107.94 273.39 107.94 268.7 168.87 233.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,220v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C47.2,219.56,47,219.68,47,220Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,221.21v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25V222a.94.94,0,0,0-.44-.75l-.48-.29C49.39,220.83,49.19,220.94,49.19,221.21Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,222.48v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.49-.28C51.58,222.09,51.38,222.2,51.38,222.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,223.74v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C53.76,223.35,53.57,223.46,53.57,223.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,225v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C56,224.61,55.76,224.72,55.76,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,226.26v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25V227a1,1,0,0,0-.43-.75l-.49-.28C58.14,225.87,58,226,58,226.26Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,227.52v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25V228.3a1,1,0,0,0-.43-.75l-.49-.28C60.33,227.13,60.14,227.25,60.14,227.52Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,228.78v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C62.52,228.4,62.32,228.51,62.32,228.78Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,230.05v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.49-.28C64.71,229.66,64.51,229.77,64.51,230.05Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,231.31v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C66.89,230.92,66.7,231,66.7,231.31Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,232.57v2.12a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C69.08,232.18,68.89,232.29,68.89,232.57Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,233.83V236a.93.93,0,0,0,.43.75L72,237c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C71.27,233.44,71.08,233.55,71.08,233.83Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,235.09v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C73.46,234.7,73.27,234.81,73.27,235.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,236.35v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28A.27.27,0,0,0,75.45,236.35Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,237.61v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25V238.4a.94.94,0,0,0-.44-.75l-.48-.29C77.84,237.23,77.64,237.34,77.64,237.61Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,238.88V241a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C80,238.49,79.83,238.6,79.83,238.88Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,240.14v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C82.21,239.75,82,239.86,82,240.14Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,226.26v2.13a1,1,0,0,0,.43.75l.49.28a.27.27,0,0,0,.43-.25V227a1,1,0,0,0-.43-.75l-.49-.28C47.2,225.87,47,226,47,226.26Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,227.52v2.13a1,1,0,0,0,.44.75l.48.28a.27.27,0,0,0,.44-.25V228.3a1,1,0,0,0-.44-.75l-.48-.28A.27.27,0,0,0,49.19,227.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,228.78v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28A.27.27,0,0,0,51.38,228.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,230.05v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75L54,229.8C53.76,229.66,53.57,229.77,53.57,230.05Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,231.31v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C56,230.92,55.76,231,55.76,231.31Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,232.57v2.12a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C58.14,232.18,58,232.29,58,232.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,233.83V236a.93.93,0,0,0,.43.75l.49.29a.27.27,0,0,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C60.33,233.44,60.14,233.55,60.14,233.83Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,235.09v2.13a1,1,0,0,0,.44.75l.48.28a.27.27,0,0,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C62.52,234.7,62.32,234.81,62.32,235.09Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,236.35v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28C64.71,236,64.51,236.08,64.51,236.35Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,237.61v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V238.4a.93.93,0,0,0-.43-.75l-.49-.29C66.89,237.23,66.7,237.34,66.7,237.61Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,238.88V241a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C69.08,238.49,68.89,238.6,68.89,238.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,240.14v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C71.27,239.75,71.08,239.86,71.08,240.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,241.4v2.12a.93.93,0,0,0,.43.75l.49.29a.27.27,0,0,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C73.46,241,73.27,241.12,73.27,241.4Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,242.66v2.13a1,1,0,0,0,.44.75l.48.28c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C75.65,242.27,75.45,242.38,75.45,242.66Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,243.92v2.13a1,1,0,0,0,.44.75l.48.28a.27.27,0,0,0,.44-.25V244.7a1,1,0,0,0-.44-.75l-.48-.28A.27.27,0,0,0,77.64,243.92Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,245.18v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V246a1,1,0,0,0-.43-.75l-.49-.28C80,244.8,79.83,244.91,79.83,245.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,246.44v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.29C82.21,246.06,82,246.17,82,246.44Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,247.33l1-.57h0a1.32,1.32,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.8,1.8,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,247.33l1-.57h0a1.32,1.32,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.8,1.8,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,247.44a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.69-1.88,1.09a4.16,4.16,0,0,1-1.88-3.26C88.82,247.33,89.66,246.84,90.7,247.44Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,252.05l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.3,1.3,0,0,1-.55,1.21h0l-.92.52-.17-.27a2.3,2.3,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,252.05l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.3,1.3,0,0,1-.55,1.21h0l-.92.52-.17-.27a2.3,2.3,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,252.16a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.68-1.88,1.08A4.17,4.17,0,0,1,97,253.24C97,252,97.83,251.56,98.87,252.16Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 184.27 107.94 221.8 172.93 184.27 107.94 146.75 42.94 184.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 203.04 107.94 240.56 107.94 221.8 42.94 184.27 42.94 203.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.94 240.56 172.93 203.04 172.93 184.27 107.94 221.8 107.94 240.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.07 212.42 51.07 207.72 107.94 240.56 107.94 245.25 51.07 212.42",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 205.38 168.87 210.07 107.94 245.25 107.94 240.56 168.87 205.38",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 205.38 168.87 210.07 107.94 245.25 107.94 240.56 168.87 205.38",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,191.81v2.13a1,1,0,0,0,.43.75l.49.28a.27.27,0,0,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C47.2,191.42,47,191.53,47,191.81Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,193.07v2.13a1,1,0,0,0,.44.75l.48.28a.27.27,0,0,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28A.27.27,0,0,0,49.19,193.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,194.33v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28A.27.27,0,0,0,51.38,194.33Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,195.59v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.29C53.76,195.21,53.57,195.32,53.57,195.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,196.86V199a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C56,196.47,55.76,196.58,55.76,196.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,198.12v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V198.9a1,1,0,0,0-.43-.75l-.49-.28C58.14,197.73,58,197.84,58,198.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,199.38v2.12a.93.93,0,0,0,.43.75l.49.29a.27.27,0,0,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C60.33,199,60.14,199.1,60.14,199.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,200.64v2.13a1,1,0,0,0,.44.75l.48.28a.27.27,0,0,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C62.52,200.25,62.32,200.36,62.32,200.64Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,201.9V204a1,1,0,0,0,.43.75l.49.28a.27.27,0,0,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28C64.71,201.51,64.51,201.63,64.51,201.9Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,203.16v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V204a.93.93,0,0,0-.43-.75l-.49-.29C66.89,202.78,66.7,202.89,66.7,203.16Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,204.43v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.28C69.08,204,68.89,204.15,68.89,204.43Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,205.69v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C71.27,205.3,71.08,205.41,71.08,205.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,207v2.12a.93.93,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C73.46,206.56,73.27,206.67,73.27,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,208.21v2.13a1,1,0,0,0,.44.75l.48.28c.24.13.44,0,.44-.25V209a1,1,0,0,0-.44-.75l-.48-.28C75.65,207.82,75.45,207.93,75.45,208.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,209.47v2.13a1,1,0,0,0,.44.75l.48.28a.27.27,0,0,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28A.27.27,0,0,0,77.64,209.47Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,210.73v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C80,210.34,79.83,210.46,79.83,210.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,212v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.29C82.21,211.61,82,211.72,82,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,198.12v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25V198.9a1,1,0,0,0-.43-.75l-.49-.28C47.2,197.73,47,197.84,47,198.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,199.38v2.12a.94.94,0,0,0,.44.75l.48.29c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C49.39,199,49.19,199.1,49.19,199.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,200.64v2.13a1,1,0,0,0,.43.75l.49.28a.27.27,0,0,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28C51.58,200.25,51.38,200.36,51.38,200.64Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,201.9V204a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C53.76,201.51,53.57,201.63,53.57,201.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,203.16v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V204a.93.93,0,0,0-.43-.75l-.49-.29C56,202.78,55.76,202.89,55.76,203.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,204.43v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.28C58.14,204,58,204.15,58,204.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,205.69v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C60.33,205.3,60.14,205.41,60.14,205.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,207v2.12a.94.94,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C62.52,206.56,62.32,206.67,62.32,207Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,208.21v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.44,0,.44-.25V209a1,1,0,0,0-.44-.75l-.49-.28C64.71,207.82,64.51,207.93,64.51,208.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,209.47v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C66.89,209.08,66.7,209.2,66.7,209.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,210.73v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C69.08,210.34,68.89,210.46,68.89,210.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,212v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12A.93.93,0,0,0,72,212l-.49-.29C71.27,211.61,71.08,211.72,71.08,212Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,213.26v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25V214a1,1,0,0,0-.43-.75L73.7,213C73.46,212.87,73.27,213,73.27,213.26Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,214.52v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25V215.3a1,1,0,0,0-.44-.75l-.48-.28C75.65,214.13,75.45,214.24,75.45,214.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,215.78v2.12a.94.94,0,0,0,.44.75l.48.29c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C77.84,215.39,77.64,215.5,77.64,215.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,217v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C80,216.65,79.83,216.76,79.83,217Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,218.3v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C82.21,217.91,82,218,82,218.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,219.19l1-.57h0a1.29,1.29,0,0,1,1.32.13A4.16,4.16,0,0,1,93.53,222a1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21A4.16,4.16,0,0,1,89.47,220a1.75,1.75,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,219.19l1-.57h0a1.29,1.29,0,0,1,1.32.13A4.16,4.16,0,0,1,93.53,222a1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21A4.16,4.16,0,0,1,89.47,220a1.75,1.75,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,219.3a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.68-1.88,1.08a4.14,4.14,0,0,1-1.88-3.25C88.82,219.19,89.66,218.7,90.7,219.3Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,223.91l1-.58h0a1.34,1.34,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.86,1.86,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,223.91l1-.58h0a1.34,1.34,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.86,1.86,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,224a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.69-1.88,1.09A4.17,4.17,0,0,1,97,225.1C97,223.9,97.83,223.41,98.87,224Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 156.13 107.94 193.66 172.93 156.13 107.94 118.61 42.94 156.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.94 174.89 107.94 212.42 107.94 193.66 42.94 156.13 42.94 174.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.94 212.42 172.93 174.89 172.93 156.13 107.94 193.66 107.94 212.42",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.07 184.27 51.07 179.58 107.94 212.42 107.94 217.11 51.07 184.27",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 177.24 168.87 181.93 107.94 217.11 107.94 212.42 168.87 177.24",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 177.24 168.87 181.93 107.94 217.11 107.94 212.42 168.87 177.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,163.67v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C47.2,163.28,47,163.39,47,163.67Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,164.93v2.12a.94.94,0,0,0,.44.75l.48.29c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C49.39,164.54,49.19,164.65,49.19,164.93Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,166.19v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.44,0,.44-.25V167a1,1,0,0,0-.44-.75l-.49-.28C51.58,165.8,51.38,165.91,51.38,166.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,167.45v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75L54,167.2C53.76,167.06,53.57,167.18,53.57,167.45Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,168.71v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C56,168.33,55.76,168.44,55.76,168.71Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,170v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.28C58.14,169.59,58,169.7,58,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,171.24v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25V172a1,1,0,0,0-.43-.75l-.49-.28C60.33,170.85,60.14,171,60.14,171.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,172.5v2.12a.94.94,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C62.52,172.11,62.32,172.22,62.32,172.5Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,173.76v2.12a1,1,0,0,0,.43.75l.49.29c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.49-.28C64.71,173.37,64.51,173.48,64.51,173.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,175v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V175.8a1,1,0,0,0-.43-.75l-.49-.28C66.89,174.63,66.7,174.75,66.7,175Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,176.28v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C69.08,175.89,68.89,176,68.89,176.28Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,177.54v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.29C71.27,177.16,71.08,177.27,71.08,177.54Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,178.81v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C73.46,178.42,73.27,178.53,73.27,178.81Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,180.07v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C75.65,179.68,75.45,179.79,75.45,180.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,181.33v2.12a.94.94,0,0,0,.44.75l.48.29c.24.13.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C77.84,180.94,77.64,181.05,77.64,181.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,182.59v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C80,182.2,79.83,182.31,79.83,182.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,183.85V186a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C82.21,183.46,82,183.58,82,183.85Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,170v2.12a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C47.2,169.59,47,169.7,47,170Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,171.24v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25V172a1,1,0,0,0-.44-.75l-.48-.28C49.39,170.85,49.19,171,49.19,171.24Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,172.5v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.49-.28C51.58,172.11,51.38,172.22,51.38,172.5Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,173.76v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C53.76,173.37,53.57,173.48,53.57,173.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,175v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V175.8a1,1,0,0,0-.43-.75l-.49-.28C56,174.63,55.76,174.75,55.76,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,176.28v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C58.14,175.89,58,176,58,176.28Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,177.54v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.29C60.33,177.16,60.14,177.27,60.14,177.54Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,178.81v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C62.52,178.42,62.32,178.53,62.32,178.81Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,180.07v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.49-.28C64.71,179.68,64.51,179.79,64.51,180.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,181.33v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C66.89,180.94,66.7,181.05,66.7,181.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,182.59v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C69.08,182.2,68.89,182.31,68.89,182.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,183.85V186a1,1,0,0,0,.43.75L72,187c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C71.27,183.46,71.08,183.58,71.08,183.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,185.11v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C73.46,184.73,73.27,184.84,73.27,185.11Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,186.37v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.29C75.65,186,75.45,186.1,75.45,186.37Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,187.64v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C77.84,187.25,77.64,187.36,77.64,187.64Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,188.9V191a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C80,188.51,79.83,188.62,79.83,188.9Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,190.16v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C82.21,189.77,82,189.88,82,190.16Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,191.05l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.3,1.3,0,0,1-.55,1.21h0l-.92.52-.17-.27a2.3,2.3,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,191.05l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.3,1.3,0,0,1-.55,1.21h0l-.92.52-.17-.27a2.3,2.3,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,191.16a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.68-1.88,1.08a4.16,4.16,0,0,1-1.88-3.26C88.82,191,89.66,190.56,90.7,191.16Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,195.76l1-.57h0a1.32,1.32,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.8,1.8,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,195.76l1-.57h0a1.32,1.32,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.8,1.8,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,195.87a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.69-1.88,1.09A4.17,4.17,0,0,1,97,197C97,195.76,97.83,195.27,98.87,195.87Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.33,126.49,110.5,92a5.8,5.8,0,0,0-5.2,0L45.54,126.49a5.76,5.76,0,0,0-2.6,4.5v15.76l65,37.52h0l65-37.52V131A5.76,5.76,0,0,0,170.33,126.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,164.63v19.64l-65-37.52V131a5.81,5.81,0,0,1,2.13-4.17c-1,.83-.79,1.94.47,2.67L105.38,164A5.31,5.31,0,0,0,108,164.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.54,129.49,105.38,164a5.72,5.72,0,0,0,5.19,0l59.76-34.52c1.44-.83,1.44-2.17,0-3L110.5,92a5.8,5.8,0,0,0-5.2,0L45.54,126.49C44.1,127.32,44.1,128.66,45.54,129.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.07 156.13 51.07 151.44 107.94 184.27 107.94 188.96 51.07 156.13",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 149.09 168.87 153.78 107.94 188.96 107.94 184.27 168.87 149.09",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 149.09 168.87 153.78 107.94 188.96 107.94 184.27 168.87 149.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,135.52v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.29C47.2,135.14,47,135.25,47,135.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,136.79v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.48-.28C49.39,136.4,49.19,136.51,49.19,136.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,138.05v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a1,1,0,0,0-.44-.75l-.49-.28C51.58,137.66,51.38,137.77,51.38,138.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,139.31v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C53.76,138.92,53.57,139,53.57,139.31Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,140.57v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C56,140.18,55.76,140.29,55.76,140.57Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,141.83V144a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C58.14,141.44,58,141.56,58,141.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,143.09v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.29C60.33,142.71,60.14,142.82,60.14,143.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,144.36v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.28C62.52,144,62.32,144.08,62.32,144.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,145.62v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25V146.4a1,1,0,0,0-.44-.75l-.49-.28C64.71,145.23,64.51,145.34,64.51,145.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,146.88V149a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C66.89,146.49,66.7,146.6,66.7,146.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,148.14v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C69.08,147.75,68.89,147.86,68.89,148.14Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,149.4v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C71.27,149,71.08,149.13,71.08,149.4Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,150.66v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C73.46,150.28,73.27,150.39,73.27,150.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,151.92v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.29C75.65,151.54,75.45,151.65,75.45,151.92Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,153.19v2.12a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25V154a1,1,0,0,0-.44-.75l-.48-.28C77.84,152.8,77.64,152.91,77.64,153.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,154.45v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C80,154.06,79.83,154.17,79.83,154.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,155.71v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C82.21,155.32,82,155.43,82,155.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,141.83V144a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C47.2,141.44,47,141.56,47,141.83Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,143.09v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.29C49.39,142.71,49.19,142.82,49.19,143.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,144.36v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.49-.28C51.58,144,51.38,144.08,51.38,144.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,145.62v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V146.4a1,1,0,0,0-.43-.75l-.49-.28C53.76,145.23,53.57,145.34,53.57,145.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,146.88V149a.93.93,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C56,146.49,55.76,146.6,55.76,146.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,148.14v2.13a1,1,0,0,0,.43.75l.49.28c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C58.14,147.75,58,147.86,58,148.14Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,149.4v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C60.33,149,60.14,149.13,60.14,149.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,150.66v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.13a1,1,0,0,0-.44-.75l-.48-.28C62.52,150.28,62.32,150.39,62.32,150.66Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,151.92v2.13a1,1,0,0,0,.43.75l.49.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.49-.29A.27.27,0,0,0,64.51,151.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,153.19v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V154a1,1,0,0,0-.43-.75l-.49-.28C66.89,152.8,66.7,152.91,66.7,153.19Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,154.45v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a1,1,0,0,0-.43-.75l-.49-.28C69.08,154.06,68.89,154.17,68.89,154.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,155.71v2.12a.93.93,0,0,0,.43.75l.49.29c.24.13.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C71.27,155.32,71.08,155.43,71.08,155.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,157v2.13a1,1,0,0,0,.43.75l.49.28c.23.14.43,0,.43-.25v-2.13a1,1,0,0,0-.43-.75l-.49-.28C73.46,156.58,73.27,156.69,73.27,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,158.23v2.13a1,1,0,0,0,.44.75l.48.28a.27.27,0,0,0,.44-.25V159a1,1,0,0,0-.44-.75l-.48-.28A.27.27,0,0,0,75.45,158.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,159.49v2.13a1,1,0,0,0,.44.75l.48.28c.24.14.44,0,.44-.25v-2.12a.94.94,0,0,0-.44-.75l-.48-.29C77.84,159.11,77.64,159.22,77.64,159.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,160.76v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25v-2.12a.93.93,0,0,0-.43-.75l-.49-.28C80,160.37,79.83,160.48,79.83,160.76Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,162v2.12a1,1,0,0,0,.43.75l.49.28c.24.14.43,0,.43-.25V162.8a1,1,0,0,0-.43-.75l-.49-.28C82.21,161.63,82,161.74,82,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,162.91l1-.58h0a1.34,1.34,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.86,1.86,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,162.91l1-.58h0a1.34,1.34,0,0,1,1.32.13,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.86,1.86,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,163a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.69-1.88,1.09a4.16,4.16,0,0,1-1.88-3.26C88.82,162.9,89.66,162.41,90.7,163Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,167.62l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,167.62l1-.57h0a1.32,1.32,0,0,1,1.32.14,4.16,4.16,0,0,1,1.88,3.26,1.33,1.33,0,0,1-.55,1.22h0l-.92.53-.17-.28a1.93,1.93,0,0,1-.54-.21,4.16,4.16,0,0,1-1.88-3.26,1.75,1.75,0,0,1,.06-.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,167.73a4.16,4.16,0,0,1,1.88,3.26c0,1.2-.84,1.68-1.88,1.08A4.17,4.17,0,0,1,97,168.81C97,167.61,97.83,167.13,98.87,167.73Z",
    style: {
      fill: "#BA1654"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.91,338.6a8.43,8.43,0,0,0,3.94,6.54l110.29,63.68a8.75,8.75,0,0,0,7.88,0l150.91-87.13a7.4,7.4,0,0,0,0-13.08l-110.3-63.67a8.67,8.67,0,0,0-7.87,0L138.85,332.07A8.42,8.42,0,0,0,134.91,338.6Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08,401.24v8.52a8,8,0,0,1-3.94-.94L138.85,345.14a7.37,7.37,0,0,1-.4-12.82c-1.77,1.26-1.63,3.12.4,4.29l110.29,63.68A8,8,0,0,0,253.08,401.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22,332.21a8.45,8.45,0,0,1-3.69-6.68V193.91a8.72,8.72,0,0,1,3.93-6.82L282.38,100a7.4,7.4,0,0,1,11.32,6.54V238.12a8.7,8.7,0,0,1-3.94,6.82L138.85,332.07A8.48,8.48,0,0,1,131.22,332.21Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38,332.3a7.37,7.37,0,0,1-10.85-6.77V193.91a8,8,0,0,1,1.15-3.88l7.39,4.26h0a8,8,0,0,0-1.16,3.87V329.79C134.91,332.12,136.43,333.17,138.38,332.3Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.91,198.17V329.79c0,2.51,1.76,3.53,3.94,2.28l150.91-87.13a8.7,8.7,0,0,0,3.94-6.82V106.5c0-2.51-1.76-3.53-3.94-2.27L138.85,191.35A8.7,8.7,0,0,0,134.91,198.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.85,336.61l110.29,63.68a8.75,8.75,0,0,0,7.88,0l150.91-87.13c2.17-1.26,2.17-3.29,0-4.55l-110.3-63.67a8.67,8.67,0,0,0-7.87,0L138.85,332.07C136.67,333.32,136.67,335.36,138.85,336.61Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.85,336.61l110.29,63.68a8.75,8.75,0,0,0,7.88,0l150.91-87.13c2.17-1.26,2.17-3.29,0-4.55l-110.3-63.67a8.67,8.67,0,0,0-7.87,0L138.85,332.07C136.67,333.32,136.67,335.36,138.85,336.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,198.66l145.5-84c1.3-.76,2.36-.15,2.36,1.36V230a5.23,5.23,0,0,1-2.36,4.09l-145.5,84c-1.31.75-2.37.14-2.37-1.36V202.75A5.2,5.2,0,0,1,141,198.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.65,333.2l140.08-80.87a4.34,4.34,0,0,1,3.94,0l7.16,4.13a1.2,1.2,0,0,1,0,2.28L162.73,339.6a4.34,4.34,0,0,1-3.94,0l-7.14-4.13A1.2,1.2,0,0,1,151.65,333.2Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.65,333.2l140.08-80.87a4.34,4.34,0,0,1,3.94,0l7.16,4.13a1.2,1.2,0,0,1,0,2.28L162.73,339.6a4.34,4.34,0,0,1-3.94,0l-7.14-4.13A1.2,1.2,0,0,1,151.65,333.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12,343.86,310.19,263a4.34,4.34,0,0,1,3.94,0l44.07,25.44a1.2,1.2,0,0,1,0,2.27L218.28,371.47a4.37,4.37,0,0,1-3.94,0l-44.22-25.34A1.2,1.2,0,0,1,170.12,343.86Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12,343.86,310.19,263a4.34,4.34,0,0,1,3.94,0l44.07,25.44a1.2,1.2,0,0,1,0,2.27L218.28,371.47a4.37,4.37,0,0,1-3.94,0l-44.22-25.34A1.2,1.2,0,0,1,170.12,343.86Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.68,299.37l4.39-2.53c.19-.11.17-.29,0-.4L295,293.51a.79.79,0,0,0-.7,0L289.89,296c-.19.1-.18.29,0,.4l5.07,2.93A.78.78,0,0,0,295.68,299.37ZM287,289.31l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,287,289.31Zm-14.17,8.18-7.42,4.29c-.19.11-.18.29,0,.4l5.07,2.93a.75.75,0,0,0,.7,0l7.42-4.28c.19-.11.18-.29,0-.4l-5.07-2.93A.79.79,0,0,0,272.86,297.49Zm7.76-4.48-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L281.32,293A.79.79,0,0,0,280.62,293ZM263.41,303,259,305.48c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.39-2.54c.18-.1.17-.29,0-.4L264.11,303A.78.78,0,0,0,263.41,303Zm-6.41,3.7-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0L262.8,310c.18-.1.17-.28,0-.4l-5.07-2.93A.78.78,0,0,0,257,306.65ZM277,318.55l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.75.75,0,0,0,277,318.55Zm-6.41,3.71,4.39-2.54c.18-.1.17-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,270.54,322.26Zm-6.41,3.7,4.39-2.54c.18-.1.17-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,264.13,326Zm-6.41,3.7,4.39-2.53c.18-.11.17-.29,0-.41L257,323.79a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,257.72,329.66Zm31.55-26.59,4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93A.75.75,0,0,0,289.27,303.07Zm-5.91,11.78,9.78-5.65c.19-.1.18-.28,0-.4l-12.32-7.11a.75.75,0,0,0-.7,0L275,304.6c-.18.11-.17.29,0,.4l6.52,3.77c.2.11.21.29,0,.4l-4.05,2.34c-.18.1-.17.29,0,.4l5.07,2.93A.78.78,0,0,0,283.36,314.85Zm-32.77-4.5-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93A.78.78,0,0,0,250.59,310.35Zm-6.41,3.7-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.92a.76.76,0,0,0,.7,0L250,317.4c.18-.11.17-.29,0-.41l-5.07-2.93A.78.78,0,0,0,244.18,314.05Zm-32,41.5a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.1-.17.29,0,.4ZM192.9,343.66l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0L198.7,347c.18-.1.17-.29,0-.4l-5.07-2.93A.78.78,0,0,0,192.9,343.66Zm10.32,8.68a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0L198.12,349c-.19.11-.17.29,0,.4Zm20.25,5.46,4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,223.47,357.8Zm-7.11,3.69a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92a.76.76,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41ZM199.31,340l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.75.75,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4L200,340A.75.75,0,0,0,199.31,340Zm32.05-18.51L227,324c-.19.11-.18.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92A.75.75,0,0,0,231.36,321.45Zm-25.64,14.81-4.39,2.53c-.18.1-.17.29,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93A.75.75,0,0,0,205.72,336.26Zm32.05-18.51-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93A.78.78,0,0,0,237.77,317.75ZM225,325.15l-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92A.75.75,0,0,0,225,325.15Zm-6.41,3.7-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93A.79.79,0,0,0,218.54,328.85Zm-6.41,3.7-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93A.79.79,0,0,0,212.13,332.55Zm32.77,4.51,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41L244.2,337A.75.75,0,0,0,244.9,337.06Zm56.3-55.93-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,301.2,281.13Zm-7.76,4.48-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,293.44,285.61Zm14.17-8.18L303.22,280c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93A.78.78,0,0,0,307.61,277.43Zm-33.18,34.21,4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.75.75,0,0,0,274.43,311.64Zm40.29-37.9a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41Zm-63.41,59.62,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0L245.51,330c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,251.31,333.36ZM329.92,288l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.1-.17.29,0,.4l5.07,2.93A.78.78,0,0,0,329.92,288Zm-13.66-.48,4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.93A.78.78,0,0,0,316.26,287.49Zm5.7-9.56a.75.75,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.41Zm1.35-.78,12.32,7.11a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-12.32-7.11a.75.75,0,0,0-.7,0l-4.38,2.53C323.1,276.85,323.11,277,323.31,277.15Zm-14.87,8.16-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93A.79.79,0,0,0,308.44,285.31ZM260.2,313.17l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93A.78.78,0,0,0,260.2,313.17Zm62.61-21.51a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm-56.2,17.81L262.22,312c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.29,0-.4l-5.07-2.93A.78.78,0,0,0,266.61,309.47Zm-48.05,42.38a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4L218.55,346a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4Zm-9.64-9.07-4.39,2.53c-.19.1-.17.29,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93A.75.75,0,0,0,208.92,342.78Zm16.75,5.38,4.38-2.53c.19-.11.18-.29,0-.4L225,342.3a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93A.78.78,0,0,0,225.67,348.16Zm6.41-3.7,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,232.08,344.46Zm6.41-3.7,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,238.49,340.76Zm-23.16-1.69-4.39,2.54c-.19.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L216,339.09A.79.79,0,0,0,215.33,339.07Zm6.41-3.7-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93A.79.79,0,0,0,221.74,335.37Zm25.64-14.8L243,323.1c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93A.78.78,0,0,0,247.38,320.57Zm-6.41,3.7-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93A.78.78,0,0,0,241,324.27Zm12.82-7.4-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93A.78.78,0,0,0,253.79,316.87Zm-25.64,14.8-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,228.15,331.67Zm6.41-3.7-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41L235.26,328A.76.76,0,0,0,234.56,328Zm-4.68,26.13,4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,229.88,354.1Zm-37.62-3.8-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.39-2.54C192.47,350.6,192.46,350.42,192.26,350.3Zm9.61,2.82-5.07-2.93a.78.78,0,0,0-.7,0l-6.75,3.89c-.19.11-.18.29,0,.41l5.08,2.92a.75.75,0,0,0,.7,0l6.74-3.9C202.08,353.42,202.07,353.23,201.87,353.12Zm-17.39-8.48-5.07-2.93a.78.78,0,0,0-.7,0l-5.4,3.11c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l5.4-3.12C184.69,344.94,184.68,344.75,184.48,344.64Zm4.14-2.39a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm22.18,14.08-5.07-2.93a.75.75,0,0,0-.7,0l-8.44,4.87c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l8.43-4.87C211,356.62,211,356.44,210.8,356.33Zm4.21,5.93-5.07-2.92a.76.76,0,0,0-.7,0l-5.4,3.12c-.19.11-.18.29,0,.4l5.08,2.93a.75.75,0,0,0,.7,0l5.39-3.11C215.22,362.56,215.21,362.38,215,362.26Zm21.27-47.53a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41Zm-12.82,7.41a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92a.76.76,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41ZM195,338.55a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L195,332.7a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.29,0,.4Zm34.84-20.12a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41Zm-12.82,7.41a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41L217,320a.76.76,0,0,0-.7,0L212,322.5c-.18.11-.17.29,0,.41Zm1.48,36.9a.75.75,0,0,0-.7,0l-6.75,3.89c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l6.75-3.9c.18-.11.17-.29,0-.4Zm-10.68-31.59a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4Zm-6.41,3.7a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L201.43,329a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4Zm135.85-40.67a.76.76,0,0,0-.7,0l-10.8,6.23c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l10.79-6.23c.19-.11.18-.29,0-.41Zm-14.17,8.18a.76.76,0,0,0-.7,0L318,304.87c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41Zm-86.83,48,4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,236.29,350.4Zm74-40.64a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4Zm33.4-19.28a.76.76,0,0,0-.7,0L338.61,293c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41Zm11.48-.78-12.32-7.11a.78.78,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.4l12.32,7.11a.75.75,0,0,0,.7,0l4.38-2.53C355.39,290,355.38,289.82,355.18,289.7Zm-68.84,33.89a.79.79,0,0,0-.7,0l-5.39,3.12c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l5.4-3.12c.19-.11.18-.29,0-.4Zm16.2-9.35a.79.79,0,0,0-.7,0l-6.75,3.9c-.19.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l6.74-3.9c.19-.11.18-.29,0-.4Zm-31,17.92a.79.79,0,0,0-.7,0L234.7,353c-.19.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l36.1-20.84c.18-.11.17-.29,0-.4Zm-38.12,22a.79.79,0,0,0-.7,0l-5.4,3.12c-.19.11-.18.29,0,.41l5.07,2.92a.76.76,0,0,0,.7,0l5.4-3.12c.19-.11.18-.29,0-.4Zm45.54-26.3a.78.78,0,0,0-.7,0l-5.4,3.12c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l5.4-3.11c.18-.11.17-.29,0-.41Zm-53,30.58a.78.78,0,0,0-.7,0l-5.39,3.12c-.19.1-.18.29,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l5.4-3.11c.19-.11.18-.29,0-.41Zm67.82-39.15a.78.78,0,0,0-.7,0l-5.4,3.12c-.19.1-.18.28,0,.4l5.08,2.93a.76.76,0,0,0,.69,0l5.4-3.11c.19-.11.18-.29,0-.41Zm22.94-13.24a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4Zm14-10.2,4.39-2.54c.19-.1.17-.28,0-.4L330,290a.78.78,0,0,0-.7,0L325,292.51c-.19.11-.18.29,0,.4l5.07,2.93A.79.79,0,0,0,330.75,295.86Zm-28.66-.19,4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93A.78.78,0,0,0,302.09,295.67Zm-14.52,25.12,12.82-7.4c.19-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-12.82,7.4c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,287.57,320.79Zm36.07-21.25a.76.76,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41Zm-6.54-4.16,4.38-2.54c.19-.1.18-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0L311.3,292c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,317.1,295.38Zm-35.94,29.11,4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,281.16,324.49Zm28.31-16.77a.76.76,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41ZM249.11,343l4.38-2.54c.19-.1.18-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,249.11,343Zm6.41-3.71,4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0L249.72,336c-.18.11-.17.29,0,.4l5.07,2.93A.75.75,0,0,0,255.52,339.29ZM242.7,346.7l4.38-2.54c.19-.1.18-.28,0-.4L242,340.83a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,242.7,346.7Zm25.64-14.81,4.38-2.53c.19-.11.18-.29,0-.4L267.63,326a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93A.78.78,0,0,0,268.34,331.89Zm-6.41,3.7,4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.29,0,.4l5.07,2.93A.78.78,0,0,0,261.93,335.59Zm12.82-7.4,4.38-2.53c.19-.11.18-.29,0-.4L274,322.33a.76.76,0,0,0-.7,0L269,324.85c-.18.1-.17.28,0,.4l5.07,2.93A.78.78,0,0,0,274.75,328.19Zm29.33-54.75a.76.76,0,0,0,.69,0l4.39-2.54c.19-.1.18-.28,0-.4l-1.35-.78a.78.78,0,0,0-.7,0l-4.39,2.53c-.19.11-.17.29,0,.4ZM272.54,293.8a.75.75,0,0,0,.7,0l4.38-2.53c.19-.1.18-.29,0-.4L272.53,288a.75.75,0,0,0-.7,0l-4.39,2.53c-.19.11-.18.29,0,.4Zm12.82-7.4a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.39,2.54c-.19.1-.18.29,0,.4Zm-20.65,11.92a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0L259.61,295c-.18.1-.17.29,0,.4ZM279,290.1a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.08-2.93a.73.73,0,0,0-.69,0l-4.39,2.53c-.19.11-.18.29,0,.4Zm-27.06,15.62a.79.79,0,0,0,.7,0L257,303.2c.19-.1.18-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm6.41-3.7a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm32.95-21.18a.76.76,0,0,0,.7,0l4.39-2.53c.19-.11.18-.29,0-.41l-1.35-.78a.78.78,0,0,0-.7,0l-4.39,2.53c-.19.11-.18.29,0,.4Zm19.24-11.1a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4L314.2,266a.75.75,0,0,0-.7,0l-4.39,2.53c-.19.11-.17.29,0,.4Zm10.65,6.15a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4L321.13,270a.78.78,0,0,0-.7,0L316,272.56c-.18.11-.17.29,0,.4Zm16,16.27,4.39-2.54c.19-.1.18-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93A.79.79,0,0,0,337.16,292.16Zm-39.49-15a.74.74,0,0,0,.69,0l4.39-2.53c.19-.11.18-.29,0-.41l-1.35-.78a.78.78,0,0,0-.7,0L296.29,276c-.19.11-.18.29,0,.4Zm-52.19,32.28a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.68,299.37l4.39-2.53c.19-.11.17-.29,0-.4L295,293.51a.79.79,0,0,0-.7,0L289.89,296c-.19.1-.18.29,0,.4l5.07,2.93A.78.78,0,0,0,295.68,299.37ZM287,289.31l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,287,289.31Zm-14.17,8.18-7.42,4.29c-.19.11-.18.29,0,.4l5.07,2.93a.75.75,0,0,0,.7,0l7.42-4.28c.19-.11.18-.29,0-.4l-5.07-2.93A.79.79,0,0,0,272.86,297.49Zm7.76-4.48-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L281.32,293A.79.79,0,0,0,280.62,293ZM263.41,303,259,305.48c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.39-2.54c.18-.1.17-.29,0-.4L264.11,303A.78.78,0,0,0,263.41,303Zm-6.41,3.7-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0L262.8,310c.18-.1.17-.28,0-.4l-5.07-2.93A.78.78,0,0,0,257,306.65ZM277,318.55l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.75.75,0,0,0,277,318.55Zm-6.41,3.71,4.39-2.54c.18-.1.17-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,270.54,322.26Zm-6.41,3.7,4.39-2.54c.18-.1.17-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,264.13,326Zm-6.41,3.7,4.39-2.53c.18-.11.17-.29,0-.41L257,323.79a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,257.72,329.66Zm31.55-26.59,4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93A.75.75,0,0,0,289.27,303.07Zm-5.91,11.78,9.78-5.65c.19-.1.18-.28,0-.4l-12.32-7.11a.75.75,0,0,0-.7,0L275,304.6c-.18.11-.17.29,0,.4l6.52,3.77c.2.11.21.29,0,.4l-4.05,2.34c-.18.1-.17.29,0,.4l5.07,2.93A.78.78,0,0,0,283.36,314.85Zm-32.77-4.5-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93A.78.78,0,0,0,250.59,310.35Zm-6.41,3.7-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.92a.76.76,0,0,0,.7,0L250,317.4c.18-.11.17-.29,0-.41l-5.07-2.93A.78.78,0,0,0,244.18,314.05Zm-32,41.5a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.1-.17.29,0,.4ZM192.9,343.66l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0L198.7,347c.18-.1.17-.29,0-.4l-5.07-2.93A.78.78,0,0,0,192.9,343.66Zm10.32,8.68a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0L198.12,349c-.19.11-.17.29,0,.4Zm20.25,5.46,4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,223.47,357.8Zm-7.11,3.69a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92a.76.76,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41ZM199.31,340l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.75.75,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4L200,340A.75.75,0,0,0,199.31,340Zm32.05-18.51L227,324c-.19.11-.18.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92A.75.75,0,0,0,231.36,321.45Zm-25.64,14.81-4.39,2.53c-.18.1-.17.29,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93A.75.75,0,0,0,205.72,336.26Zm32.05-18.51-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93A.78.78,0,0,0,237.77,317.75ZM225,325.15l-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92A.75.75,0,0,0,225,325.15Zm-6.41,3.7-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93A.79.79,0,0,0,218.54,328.85Zm-6.41,3.7-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4l-5.07-2.93A.79.79,0,0,0,212.13,332.55Zm32.77,4.51,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41L244.2,337A.75.75,0,0,0,244.9,337.06Zm56.3-55.93-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,301.2,281.13Zm-7.76,4.48-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,293.44,285.61Zm14.17-8.18L303.22,280c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93A.78.78,0,0,0,307.61,277.43Zm-33.18,34.21,4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.75.75,0,0,0,274.43,311.64Zm40.29-37.9a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41Zm-63.41,59.62,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0L245.51,330c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,251.31,333.36ZM329.92,288l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.1-.17.29,0,.4l5.07,2.93A.78.78,0,0,0,329.92,288Zm-13.66-.48,4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.93A.78.78,0,0,0,316.26,287.49Zm5.7-9.56a.75.75,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.41Zm1.35-.78,12.32,7.11a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-12.32-7.11a.75.75,0,0,0-.7,0l-4.38,2.53C323.1,276.85,323.11,277,323.31,277.15Zm-14.87,8.16-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93A.79.79,0,0,0,308.44,285.31ZM260.2,313.17l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93A.78.78,0,0,0,260.2,313.17Zm62.61-21.51a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm-56.2,17.81L262.22,312c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.29,0-.4l-5.07-2.93A.78.78,0,0,0,266.61,309.47Zm-48.05,42.38a.78.78,0,0,0,.7,0l4.39-2.53c.18-.11.17-.29,0-.4L218.55,346a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4Zm-9.64-9.07-4.39,2.53c-.19.1-.17.29,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93A.75.75,0,0,0,208.92,342.78Zm16.75,5.38,4.38-2.53c.19-.11.18-.29,0-.4L225,342.3a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93A.78.78,0,0,0,225.67,348.16Zm6.41-3.7,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,232.08,344.46Zm6.41-3.7,4.39-2.53c.18-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,238.49,340.76Zm-23.16-1.69-4.39,2.54c-.19.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L216,339.09A.79.79,0,0,0,215.33,339.07Zm6.41-3.7-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93A.79.79,0,0,0,221.74,335.37Zm25.64-14.8L243,323.1c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93A.78.78,0,0,0,247.38,320.57Zm-6.41,3.7-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93A.78.78,0,0,0,241,324.27Zm12.82-7.4-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93A.78.78,0,0,0,253.79,316.87Zm-25.64,14.8-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92A.76.76,0,0,0,228.15,331.67Zm6.41-3.7-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41L235.26,328A.76.76,0,0,0,234.56,328Zm-4.68,26.13,4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.92A.75.75,0,0,0,229.88,354.1Zm-37.62-3.8-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l4.39-2.54C192.47,350.6,192.46,350.42,192.26,350.3Zm9.61,2.82-5.07-2.93a.78.78,0,0,0-.7,0l-6.75,3.89c-.19.11-.18.29,0,.41l5.08,2.92a.75.75,0,0,0,.7,0l6.74-3.9C202.08,353.42,202.07,353.23,201.87,353.12Zm-17.39-8.48-5.07-2.93a.78.78,0,0,0-.7,0l-5.4,3.11c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l5.4-3.12C184.69,344.94,184.68,344.75,184.48,344.64Zm4.14-2.39a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm22.18,14.08-5.07-2.93a.75.75,0,0,0-.7,0l-8.44,4.87c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l8.43-4.87C211,356.62,211,356.44,210.8,356.33Zm4.21,5.93-5.07-2.92a.76.76,0,0,0-.7,0l-5.4,3.12c-.19.11-.18.29,0,.4l5.08,2.93a.75.75,0,0,0,.7,0l5.39-3.11C215.22,362.56,215.21,362.38,215,362.26Zm21.27-47.53a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41Zm-12.82,7.41a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92a.76.76,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41ZM195,338.55a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L195,332.7a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.29,0,.4Zm34.84-20.12a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41Zm-12.82,7.41a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41L217,320a.76.76,0,0,0-.7,0L212,322.5c-.18.11-.17.29,0,.41Zm1.48,36.9a.75.75,0,0,0-.7,0l-6.75,3.89c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l6.75-3.9c.18-.11.17-.29,0-.4Zm-10.68-31.59a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4Zm-6.41,3.7a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4L201.43,329a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4Zm135.85-40.67a.76.76,0,0,0-.7,0l-10.8,6.23c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l10.79-6.23c.19-.11.18-.29,0-.41Zm-14.17,8.18a.76.76,0,0,0-.7,0L318,304.87c-.18.11-.17.29,0,.41l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41Zm-86.83,48,4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,236.29,350.4Zm74-40.64a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4Zm33.4-19.28a.76.76,0,0,0-.7,0L338.61,293c-.18.11-.17.29,0,.41l5.07,2.92a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.41Zm11.48-.78-12.32-7.11a.78.78,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.4l12.32,7.11a.75.75,0,0,0,.7,0l4.38-2.53C355.39,290,355.38,289.82,355.18,289.7Zm-68.84,33.89a.79.79,0,0,0-.7,0l-5.39,3.12c-.19.11-.18.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l5.4-3.12c.19-.11.18-.29,0-.4Zm16.2-9.35a.79.79,0,0,0-.7,0l-6.75,3.9c-.19.11-.17.29,0,.4l5.07,2.93a.79.79,0,0,0,.7,0l6.74-3.9c.19-.11.18-.29,0-.4Zm-31,17.92a.79.79,0,0,0-.7,0L234.7,353c-.19.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l36.1-20.84c.18-.11.17-.29,0-.4Zm-38.12,22a.79.79,0,0,0-.7,0l-5.4,3.12c-.19.11-.18.29,0,.41l5.07,2.92a.76.76,0,0,0,.7,0l5.4-3.12c.19-.11.18-.29,0-.4Zm45.54-26.3a.78.78,0,0,0-.7,0l-5.4,3.12c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l5.4-3.11c.18-.11.17-.29,0-.41Zm-53,30.58a.78.78,0,0,0-.7,0l-5.39,3.12c-.19.1-.18.29,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l5.4-3.11c.19-.11.18-.29,0-.41Zm67.82-39.15a.78.78,0,0,0-.7,0l-5.4,3.12c-.19.1-.18.28,0,.4l5.08,2.93a.76.76,0,0,0,.69,0l5.4-3.11c.19-.11.18-.29,0-.41Zm22.94-13.24a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4Zm14-10.2,4.39-2.54c.19-.1.17-.28,0-.4L330,290a.78.78,0,0,0-.7,0L325,292.51c-.19.11-.18.29,0,.4l5.07,2.93A.79.79,0,0,0,330.75,295.86Zm-28.66-.19,4.39-2.53c.19-.11.17-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.38,2.54c-.19.1-.18.28,0,.4l5.07,2.93A.78.78,0,0,0,302.09,295.67Zm-14.52,25.12,12.82-7.4c.19-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-12.82,7.4c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,287.57,320.79Zm36.07-21.25a.76.76,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.41l-5.07-2.93a.78.78,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41Zm-6.54-4.16,4.38-2.54c.19-.1.18-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0L311.3,292c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,317.1,295.38Zm-35.94,29.11,4.38-2.53c.19-.11.18-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.41l5.07,2.93A.78.78,0,0,0,281.16,324.49Zm28.31-16.77a.76.76,0,0,0,.7,0l4.39-2.53c.19-.11.17-.29,0-.41l-5.07-2.92a.75.75,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.41ZM249.11,343l4.38-2.54c.19-.1.18-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,249.11,343Zm6.41-3.71,4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0L249.72,336c-.18.11-.17.29,0,.4l5.07,2.93A.75.75,0,0,0,255.52,339.29ZM242.7,346.7l4.38-2.54c.19-.1.18-.28,0-.4L242,340.83a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4l5.07,2.93A.79.79,0,0,0,242.7,346.7Zm25.64-14.81,4.38-2.53c.19-.11.18-.29,0-.4L267.63,326a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.28,0,.4l5.07,2.93A.78.78,0,0,0,268.34,331.89Zm-6.41,3.7,4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.39,2.54c-.18.1-.17.29,0,.4l5.07,2.93A.78.78,0,0,0,261.93,335.59Zm12.82-7.4,4.38-2.53c.19-.11.18-.29,0-.4L274,322.33a.76.76,0,0,0-.7,0L269,324.85c-.18.1-.17.28,0,.4l5.07,2.93A.78.78,0,0,0,274.75,328.19Zm29.33-54.75a.76.76,0,0,0,.69,0l4.39-2.54c.19-.1.18-.28,0-.4l-1.35-.78a.78.78,0,0,0-.7,0l-4.39,2.53c-.19.11-.17.29,0,.4ZM272.54,293.8a.75.75,0,0,0,.7,0l4.38-2.53c.19-.1.18-.29,0-.4L272.53,288a.75.75,0,0,0-.7,0l-4.39,2.53c-.19.11-.18.29,0,.4Zm12.82-7.4a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.79.79,0,0,0-.7,0l-4.39,2.54c-.19.1-.18.29,0,.4Zm-20.65,11.92a.78.78,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0L259.61,295c-.18.1-.17.29,0,.4ZM279,290.1a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.08-2.93a.73.73,0,0,0-.69,0l-4.39,2.53c-.19.11-.18.29,0,.4Zm-27.06,15.62a.79.79,0,0,0,.7,0L257,303.2c.19-.1.18-.29,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm6.41-3.7a.75.75,0,0,0,.7,0l4.38-2.53c.19-.11.18-.29,0-.4l-5.07-2.93a.75.75,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Zm32.95-21.18a.76.76,0,0,0,.7,0l4.39-2.53c.19-.11.18-.29,0-.41l-1.35-.78a.78.78,0,0,0-.7,0l-4.39,2.53c-.19.11-.18.29,0,.4Zm19.24-11.1a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4L314.2,266a.75.75,0,0,0-.7,0l-4.39,2.53c-.19.11-.17.29,0,.4Zm10.65,6.15a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4L321.13,270a.78.78,0,0,0-.7,0L316,272.56c-.18.11-.17.29,0,.4Zm16,16.27,4.39-2.54c.19-.1.18-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.38,2.53c-.19.11-.18.29,0,.4l5.07,2.93A.79.79,0,0,0,337.16,292.16Zm-39.49-15a.74.74,0,0,0,.69,0l4.39-2.53c.19-.11.18-.29,0-.41l-1.35-.78a.78.78,0,0,0-.7,0L296.29,276c-.19.11-.18.29,0,.4Zm-52.19,32.28a.79.79,0,0,0,.7,0l4.38-2.54c.19-.1.18-.28,0-.4l-5.07-2.93a.78.78,0,0,0-.7,0l-4.39,2.53c-.18.11-.17.29,0,.4Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,347.9l43.29-25a5.23,5.23,0,0,1,4.72,0l24.82,14.33c1.3.75,1.3,2,0,2.73l-43.28,25a5.19,5.19,0,0,1-4.73,0L273.9,350.63C272.6,349.87,272.6,348.65,273.9,347.9Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,347.9l43.29-25a5.23,5.23,0,0,1,4.72,0l24.82,14.33c1.3.75,1.3,2,0,2.73l-43.28,25a5.19,5.19,0,0,1-4.73,0L273.9,350.63C272.6,349.87,272.6,348.65,273.9,347.9Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22,332.2a6,6,0,0,0,1.21.52,5.5,5.5,0,0,1-1.21-.51,2.4,2.4,0,0,1-.37-.25A3.37,3.37,0,0,0,131.22,332.2Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.66,105.86c-.28-2-1.92-2.78-3.9-1.64L138.85,191.36a7.93,7.93,0,0,0-2.79,2.92L128.68,190a8,8,0,0,1,2.78-2.94L282.38,100a7.36,7.36,0,0,1,11.28,5.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11,332.57s0,0,.06-.05l0,0Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.87,315.15a8.45,8.45,0,0,1-3.94,6.54L257,408.82a8.13,8.13,0,0,1-3.94.92v-8.51a8,8,0,0,0,3.94-.94l150.91-87.13c2-1.18,2.16-3,.4-4.29A8.52,8.52,0,0,1,411.87,315.15Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.37,303.34c0,1.86,1.31,2.61,2.92,1.68L280.78,228a6.45,6.45,0,0,0,2.92-5V133L144.37,213.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.13,194.51v4.32c0,.88.63,1.24,1.39.8l27.72-16.09V176L196.52,192.1A3.1,3.1,0,0,0,195.13,194.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.55,171.79c.77-.44,1.39-.08,1.39.8v4.32a3.06,3.06,0,0,1-1.39,2.41l-7.31,4.22V176Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,177.72l-.82-.26a4.14,4.14,0,0,0,.13-1.05,1.92,1.92,0,0,0-.74-1.74,1.16,1.16,0,0,0-1.19.06,4.17,4.17,0,0,0-1.63,3.39,1.92,1.92,0,0,0,.75,1.74,1,1,0,0,0,.51.14,1.33,1.33,0,0,0,.67-.2A3.41,3.41,0,0,0,230,178l.82.25.09,0a.32.32,0,0,0,.29-.22A.29.29,0,0,0,231,177.72Zm-2.62,1.56a.54.54,0,0,1-.58.05,1.4,1.4,0,0,1-.44-1.21,3.67,3.67,0,0,1,1.32-2.87.85.85,0,0,1,.37-.11.54.54,0,0,1,.22.05,1.44,1.44,0,0,1,.44,1.22A3.65,3.65,0,0,1,228.39,179.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.37,207.37a6.45,6.45,0,0,1,2.92-5l133.49-77.08c1.61-.93,2.92-.17,2.92,1.68V133L144.37,213.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.31,136.18a3,3,0,0,0-1.37,2.37c0,.87.61,1.22,1.37.79a3,3,0,0,0,1.36-2.37C268.67,136.1,268.06,135.75,267.31,136.18Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.09,133.43a3,3,0,0,0-1.37,2.36c0,.88.61,1.23,1.37.79a3,3,0,0,0,1.36-2.36C273.45,133.35,272.84,133,272.09,133.43Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.87,130.68A3,3,0,0,0,275.5,133c0,.87.61,1.23,1.37.79a3,3,0,0,0,1.36-2.37C278.23,130.59,277.62,130.24,276.87,130.68Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,305,280.78,228a6.45,6.45,0,0,0,2.92-5V157.85L144.37,238.28v65.06C144.37,305.2,145.68,306,147.29,305Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.83,193l20.36-11.75c.78-.45,1.41-.14,1.41.71a3,3,0,0,1-1.41,2.35l-20.33,11.67c-.79.45-1.43.15-1.43-.67A3,3,0,0,1,198.83,193Z",
    style: {
      fill: "#455a64",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,244.81c-.13.07-.23.08-.3,0l-.16-.17L191.5,239v7.49a.85.85,0,0,1-.1.4.56.56,0,0,1-.22.27l-1,.56a.17.17,0,0,1-.22,0,.4.4,0,0,1-.09-.29V235.67a.93.93,0,0,1,.09-.4.6.6,0,0,1,.22-.28l.83-.47c.13-.08.24-.09.31,0l.15.17,3.31,5.65v-7.49a1,1,0,0,1,.09-.4.62.62,0,0,1,.22-.27l1-.55a.17.17,0,0,1,.22,0,.37.37,0,0,1,.1.29v11.74a.82.82,0,0,1-.1.4.54.54,0,0,1-.22.28Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,235.26a12,12,0,0,1,.25-2.06,8.77,8.77,0,0,1,.65-1.93,7.27,7.27,0,0,1,1.06-1.67,5.4,5.4,0,0,1,1.51-1.26,2.89,2.89,0,0,1,1.5-.49,1.51,1.51,0,0,1,1.06.44,2.82,2.82,0,0,1,.65,1.19,7,7,0,0,1,.26,1.78c0,.22,0,.47,0,.75v1.73c0,.28,0,.54,0,.77a12,12,0,0,1-.25,2.06,8.85,8.85,0,0,1-.65,1.94,7,7,0,0,1-1.07,1.66,5.81,5.81,0,0,1-1.5,1.25,3,3,0,0,1-1.51.49,1.48,1.48,0,0,1-1.06-.43,2.6,2.6,0,0,1-.65-1.19,7.7,7.7,0,0,1-.25-1.77c0-.23,0-.48,0-.75s0-.57,0-.86,0-.59,0-.87S198,235.5,198,235.26Zm5.35-3a2.39,2.39,0,0,0-.55-1.71c-.34-.29-.78-.27-1.33.05a3.45,3.45,0,0,0-1.33,1.48,5.73,5.73,0,0,0-.55,2.35c0,.47,0,1,0,1.55s0,1.07,0,1.52a2.32,2.32,0,0,0,.55,1.7c.34.28.78.26,1.33-.06a3.45,3.45,0,0,0,1.33-1.48,5.75,5.75,0,0,0,.55-2.33c0-.47,0-1,0-1.55S203.33,232.72,203.32,232.27Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39,222.19a3.43,3.43,0,0,1,1.52-.52,1.47,1.47,0,0,1,1.08.39,2.73,2.73,0,0,1,.66,1.2,8.35,8.35,0,0,1,.27,1.91c0,.88,0,1.78,0,2.69a13.08,13.08,0,0,1-.27,2.23,9.6,9.6,0,0,1-.66,2,6.57,6.57,0,0,1-1.06,1.62,5.81,5.81,0,0,1-1.48,1.21l-3,1.72a.18.18,0,0,1-.23,0,.39.39,0,0,1-.09-.29V224.55a1,1,0,0,1,.09-.4.63.63,0,0,1,.23-.27Zm1.94,3.9a4.13,4.13,0,0,0-.15-1,1.49,1.49,0,0,0-.36-.66.87.87,0,0,0-.61-.23,1.88,1.88,0,0,0-.87.3l-1.59.91v8.18l1.64-1a2.82,2.82,0,0,0,.84-.69,3.84,3.84,0,0,0,.59-.91,4.9,4.9,0,0,0,.36-1.08,6.68,6.68,0,0,0,.15-1.18C214.36,227.87,214.36,227,214.33,226.09Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.18,217.12c.12-.07.22-.07.28,0a1,1,0,0,1,.17.37l2.89,9.82a.41.41,0,0,1,0,.12,1,1,0,0,1-.09.4.63.63,0,0,1-.23.27l-.85.49c-.16.09-.27.11-.33,0a.56.56,0,0,1-.13-.22l-.51-1.73-3.73,2.15-.5,2.32a1.94,1.94,0,0,1-.14.37.79.79,0,0,1-.33.35l-.85.49a.17.17,0,0,1-.22,0,.4.4,0,0,1-.09-.29.53.53,0,0,1,0-.13l2.89-13.16a3.26,3.26,0,0,1,.16-.56.7.7,0,0,1,.29-.32Zm.65,7.61-1.3-4.43-1.3,5.93Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.27,211.87a.17.17,0,0,1,.22,0,.4.4,0,0,1,.1.29v1.29a1,1,0,0,1-.1.4.65.65,0,0,1-.22.28l-2.13,1.22v10a.93.93,0,0,1-.09.4.61.61,0,0,1-.23.28l-.95.55a.18.18,0,0,1-.23,0,.39.39,0,0,1-.09-.29v-10l-2.13,1.23a.17.17,0,0,1-.22,0,.39.39,0,0,1-.1-.29v-1.29a1,1,0,0,1,.1-.4.62.62,0,0,1,.22-.27Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.81,209.25c.13-.07.22-.08.28,0a.85.85,0,0,1,.17.37l2.89,9.82a.37.37,0,0,1,0,.12,1,1,0,0,1-.1.4.62.62,0,0,1-.22.27l-.85.49c-.16.09-.27.1-.33,0a.45.45,0,0,1-.13-.23L236,218.8,232.3,221l-.51,2.31a1.9,1.9,0,0,1-.13.38.72.72,0,0,1-.33.34l-.85.49a.17.17,0,0,1-.22,0,.37.37,0,0,1-.1-.29.61.61,0,0,1,0-.14l2.89-13.15a2.92,2.92,0,0,1,.17-.56.68.68,0,0,1,.28-.32Zm.65,7.6-1.3-4.43-1.3,5.93Z",
    style: {
      fill: "#BA1654"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.41,276.92c1.42-28.8-.73-35.76-8.29-41.21l-3.34,16.63s3.05,19.75,2.52,26.3c-.45,5.75-1.18,12.94-2.64,17.56a3.55,3.55,0,0,1-1.57,1.94c-2,1.18-2.8,2.41-4.31,3.92-1.18,1.18-2.16,1.46-2,1.85a1.9,1.9,0,0,0,2.41.91,13.08,13.08,0,0,0,2.8-1.44,17.63,17.63,0,0,1-2.94,4.81c-2.82,3.3-3,5.36,2.54,5.53,3.47.11,6.28-2,9.06-9.54a61.67,61.67,0,0,0,2.63-8.52C456.75,288.13,458.18,281.55,458.41,276.92Z",
    style: {
      fill: "#a35b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.72,233.38c3.67-.45,8.63.43,11.72,6.25s3.65,15.73,3.79,25.58c0,0-6.5,5.19-14.11,2.39Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.72,233.38c3.67-.45,8.63.43,11.72,6.25s3.65,15.73,3.79,25.58c0,0-6.5,5.19-14.11,2.39Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.79,384.23c.54.22.66,1.28.7,3.37,0,1.59.3,4.36-1.57,4.87s-4.58.17-5.73-1.35a73.53,73.53,0,0,0-4.48-5.88c-1.79-2-3.74-3.9-4.42-6.69-.61-2.51,0-3.58,1.69-4.27,2.37-.95,6,2.4,7.81,3C446.36,377.71,450.24,384,450.79,384.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.83,382.29l-.06,2.57a6.31,6.31,0,0,1-6.5,0c-.1-.25-.59-3.69-.59-3.69Z",
    style: {
      fill: "#a35b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.64,398.57s.68,2.25,1,4.22c.28,1.56.67,4.17.1,5.32s-2.71,1.87-6,1.77c-2.13-.07-5.48,1.31-7.79,2.52s-7.27,1.67-9.75,1.33c-2.92-.41-5.92-2.18-6.36-3.4s.21-2.47,7.18-5.26c.06,0,9.66-2.91,13.08-6.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.7,395.79s-.05,1.91-.07,3-1.34,2.69-4.67,2.49c-2.34-.13-4-.8-3.82-2.73l.06-2.77Z",
    style: {
      fill: "#a35b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.27,348.22a70.32,70.32,0,0,0-2.73-13.46s1.17-11.53,1.86-22.47c.74-11.82.58-26.7.87-29.64,0,0-38-8.58-39,5.07s.41,48.52.73,54.54,1.23,11.35,2.25,21.11,3.93,32.41,3.93,32.41a9,9,0,0,0,8.5,0s3.3-27.28,3.18-34.21a59.54,59.54,0,0,0-2.29-15.19s1-11.26,1.83-21.05,1.65-14.49,1.89-18.75l.83-.39s.46,16.94.77,22.95,1.15,11.8,2.63,23c1.29,9.71,5.32,30.29,5.32,30.29,4.31,2.46,7-.15,7-.15S454.26,356.64,453.27,348.22Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.27,348.22a70.32,70.32,0,0,0-2.73-13.46s1.17-11.53,1.86-22.47c.74-11.82.58-26.7.87-29.64,0,0-38-8.58-39,5.07s.41,48.52.73,54.54,1.23,11.35,2.25,21.11,3.93,32.41,3.93,32.41a9,9,0,0,0,8.5,0s3.3-27.28,3.18-34.21a59.54,59.54,0,0,0-2.29-15.19s1-11.26,1.83-21.05,1.65-14.49,1.89-18.75l.83-.39s.46,16.94.77,22.95,1.15,11.8,2.63,23c1.29,9.71,5.32,30.29,5.32,30.29,4.31,2.46,7-.15,7-.15S454.26,356.64,453.27,348.22Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.31,306.59s9.36-4.36,14.09-8.37c0,0-4.44,6-10.15,8.53,0,0-2.48,21-2.46,20.56l-.69-20.74Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.82 228.64 429.8 241.12 441.05 240.55 439.74 225.95 427.82 228.64",
    style: {
      fill: "#a35b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.93,239.91c-1-3.4-5.24-7.18-9.55-6.48-1,.16-2,.33-2.93.5-.51,2.1-5.89,3.72-11.4,2.43-1.66.43-3.19.88-4.57,1.34-4,1.31-7.61,4.63-8.23,17.54,0,0-2,30.1-2.15,35.92,9.78,4.13,20,4.24,25.74,3.13,11.86-2.31,13.4-7.18,13.4-7.18s.64-21.66.49-31C453.61,248.13,453.64,242.25,452.93,239.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.5,213.32s-2.95,4.48-2.61,4.92,2.5.83,2.5.83Z",
    style: {
      fill: "#8c3f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.88,216.2a3.52,3.52,0,1,1,3.51-3.52A3.52,3.52,0,0,1,420.88,216.2Zm0-6.25a2.74,2.74,0,1,0,2.73,2.73A2.73,2.73,0,0,0,420.88,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.69,200.94c-6,1.26-7.69,3.88-8.25,13.37-.59,9.9.42,13,1.72,14.35.88.9,5.76,1.06,8.23.39,3.08-.85,10.05-3.32,13.31-8.31,3.84-5.86,4.85-13.81.74-17.07C437.65,199.09,430.12,200.43,427.69,200.94Z",
    style: {
      fill: "#a35b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.27,229.15a17.81,17.81,0,0,0,5.71.16,4.74,4.74,0,0,0,1.92-2.19S428.77,228.7,422.27,229.15Z",
    style: {
      fill: "#8c3f3e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.69 211.95 428.31 213.32 427.88 214.07 417.69 212.75 417.69 211.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.64,205.61a9,9,0,0,0,3.39,3.25c1.49.78,3,.82,4.64,2.42a7.42,7.42,0,0,1,1.46,2.09c.07.17,1.33,1.87,1.4,1.61,0,0,.94-3.66,4-3.2s3.53,4.42,1.57,6.83-3.79,1.48-3.79,1.48.1,5.24,2.42,8.2c0,0,2.64.86,7.49-.18,3-.64,7.21-4.37,9-8.31,3.75-8.36,4-15.88-1.32-18.13-.58-3.85-3.61-5.58-7.06-6.37a17.06,17.06,0,0,0-5.57-.07,15.48,15.48,0,0,1-6.2-.58,8.83,8.83,0,0,0-3.32-.7c-1.13.11-2.29,1.06-2.13,2.18a5.32,5.32,0,0,0-6,.12c-2.12,1.58-2.16,3.95-1.38,6.31A14.3,14.3,0,0,0,416.64,205.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,203l3.58-2.11A2.08,2.08,0,0,0,447,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.47,217.07l.11-4.15a2.08,2.08,0,1,0-.11,4.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.88,240.14c-7.53-5.08-22.38-16-24.18-17.14-2.5-1.53-6.33-1.88-8.68-.63-2.18,1.17-.95,4.09,3.27,9.07,4.09,4.82,21.86,23,21.86,23Z",
    style: {
      fill: "#a35b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.29,238.36c-5.24-3.32-16-10-16-10s-7.42,5.33-5.7,14.28c0,0,10.78,10.33,14,13,2.18,1.76,8.47-1,9.36-7.32C427.12,240.51,424.29,238.36,424.29,238.36Z",
    style: {
      fill: "#BA1654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.29,238.36c-5.24-3.32-16-10-16-10s-7.42,5.33-5.7,14.28c0,0,10.78,10.33,14,13,2.18,1.76,8.47-1,9.36-7.32C427.12,240.51,424.29,238.36,424.29,238.36Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,224.05c.57-4.13,13.26-12.87,17.6-15.56a32.39,32.39,0,0,0,5.45-4.17c.66-.64,1.24-1.35,1.89-2s1.21-1.54,2-2.22a13.68,13.68,0,0,1,3.16-2.3,10.76,10.76,0,0,1,7-.5c.54.12,1.08.27,1.64.34,1.17.15,2.5,0,3.41.72a.82.82,0,0,1,.36.6c0,.38-.37.62-.71.79-2.67,1.3-5.82,1.74-8.05,3.71-.17.15-1.21,1.52-.64,1.67s2.51-.65,4.61-.59c2.53.07.86,1.53,0,2a15.3,15.3,0,0,1-4.38,1.69c-2.36.57-4.42.83-6,1.88s-15.64,15.27-15.64,15.27Z",
    style: {
      fill: "#a35b5a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.85606daafabe6b8ca1cd95a3adfd6411.svg";
export { ForwardRef as ReactComponent };